// extracted by mini-css-extract-plugin
export var largeBgImage = "LargeBGImg-module--largeBgImage--vhgqL";
export var caption = "LargeBGImg-module--caption--2nWiS";
export var boldTitle = "LargeBGImg-module--boldTitle--3Udpl";